import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

export async function listOperatorRequests({ status, date_from, date_to } = {}) {
    const url = new URL(`${API_BASE}/requests/operator`);
    if (status) url.searchParams.set("status", status);
    if (date_from) url.searchParams.set("date_from", date_from);
    if (date_to) url.searchParams.set("date_to", date_to);

    const res = await apiFetch(url.toString());
    if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || "Не вдалося завантажити заявки");
    }
    return await res.json();
}

export async function closeOperatorRequest({ requestId, operator_comment }) {
    const res = await apiFetch(`${API_BASE}/requests/operator/${requestId}/close`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ operator_comment }),
    });
    if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || "Не вдалося закрити заявку");
    }
    return await res.json();
}

export async function addOperatorRequestMessage(requestId, body) {
    const res = await apiFetch(`${API_BASE}/requests/operator/${requestId}/messages`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ body }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося додати відповідь");
    }
    return await res.json();
}

export function operatorRequestAttachmentUrl(fileUrl) {
    if (!fileUrl) return "";
    return `${API_BASE}/requests/operator/download/${encodeURIComponent(fileUrl)}`;
}

export async function fetchOperatorRequestAttachmentBlob(fileUrl) {
    const res = await apiFetch(operatorRequestAttachmentUrl(fileUrl));
    if (!res.ok) throw new Error("Не вдалося завантажити файл");
    return await res.blob();
}
